import React from 'react';

import {Field} from 'redux-form';

import {required} from 'utils/validators';

import FormField from 'components/FormField';
import Label from 'components/Label';
import {CheckBoxField, NumberField, RadioField} from 'components/Fields';

import './styles.css';

class BreakClauseSection extends React.Component<any> {
  state = {
    breakClauseType: null
  };

  onRadioButtonChange = event => {
    this.setState({breakClauseType: event.target.value});
  };

  render() {
    const {breakClauseType} = this.state;
    const {includeBreakClause, onIncludeBreakClauseChange} = this.props;

    return (
      <div className="breakClauseSection">
        <Field
          name="includeBreakClause"
          component={CheckBoxField}
          onChange={onIncludeBreakClauseChange}
          label="Include break clause"
          className="includeBreakClause"
        />

        {includeBreakClause && (
          <div className="breakClauseFields">
            <FormField className="breakClauseTypeFormField">
              <div className="fixedTypeOption">
                <Label className="displayLabel">
                  <Field
                    name="breakClause.type"
                    component={RadioField}
                    optionValue="fixed"
                    checked={breakClauseType === 'fixed'}
                    onChange={this.onRadioButtonChange}
                  />
                  <div className="label">Fixed</div>
                </Label>
              </div>

              <div className="flexibleTypeOption">
                <Label className="displayLabel">
                  <Field
                    name="breakClause.type"
                    component={RadioField}
                    checked={breakClauseType === 'flexible'}
                    optionValue="flexible"
                    onChange={this.onRadioButtonChange}
                  />
                  <div className="label">Flexible</div>
                </Label>
              </div>
            </FormField>

            <FormField>
              <Label>Break clause period</Label>
              <Field
                name="breakClause.periodMonths"
                validate={[required]}
                component={NumberField}
                className="breakClausePeriod"
              />
            </FormField>
            <FormField>
              <Label>Notice period</Label>
              <Field
                name="breakClause.noticePeriodMonths"
                validate={[required]}
                component={NumberField}
                className="noticePeriod"
              />
            </FormField>
          </div>
        )}
      </div>
    );
  }
}

export default BreakClauseSection;
